<template>
  <div class="container">
    <a href="#" name="top"></a>
    <a class="toTop" href="top" v-bind:style="{right: topRight+'px'}">
      <img src="../../assets/images/top.png" alt="返回顶部" />
    </a>
    <my-menu menu-name="discovery"></my-menu>

    <div class="c_content clearfix">
      <ol class="breadcrumb">
        <li>
          当前位置：
        </li>
        <li>
          <router-link :to="{name:'Discovery'}">发现</router-link>
        </li>
        <li class="sep">
          <a href="javascript:;">维学课堂</a>
        </li>
        <li class="sep active">
          正文
        </li>
      </ol>

      <div class="c_detail">
        <h1>{{class_detail.title}}</h1>
        <span class="c_from">{{class_detail.date}} 来源：维克多英语</span>
        <div v-html="class_detail.content"></div>
      </div>    
      <hr style="height: 3px; background-color: #333;width:100%''">
      <div class="recommend clearfix">
        <h2>精彩推荐</h2>
        <ul>
          <li>
            <a href="javascript:;" class="recommend_desc">
              英语八大时态用法详解态用法详解态
            </a>
          </li>
          <li>
            <a href="javascript:;" class="recommend_desc">
              英语八大时态用法详解态用法详解态用法详解
            </a>
          </li>
          <li>
            <a href="javascript:;" class="recommend_desc">
              英语八大时态用法详解
            </a>
          </li>
          <li>
            <a href="javascript:;" class="recommend_desc">
              英语八大时态用法详解态用法详解态
            </a>
          </li>
          <li>
            <a href="javascript:;" class="recommend_desc">
              英语八大时态用法详解态
            </a>
          </li>
          <li>
            <a href="javascript:;" class="recommend_desc">
              英语八大时态用法详解态用法详解态用法详解
            </a>
          </li>
        </ul>
      </div>
    </div>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'

  import Classes from '@/assets/data/classes'
  export default {
    data () {
      return {
        id: 0,
        class_detail: {},
        topRight: 0
      }
    },
    components: {
      MyFooter,
      MyMenu
    },
    created () {
      const vm = this
      vm.id = vm.$route.params.id
      if (typeof Classes.classes !== 'undefined') {
        vm.class_detail = Classes.classes.find((ele) => {
          return parseInt(vm.id) === ele.id
        })
      }

      this.init()
    },
    watch: {
      $route () {
        const vm = this
        vm.id = vm.$route.params.id
        if (typeof Classes.classes !== 'undefined') {
          vm.class_detail = Classes.classes.find((ele) => {
            return parseInt(vm.id) === ele.id
          })
        }
      }
    },
    methods: {
      init () {
        const vm = this
        let wWidth = document.documentElement.clientWidth || document.body.clientWidth
        // let wHeight = document.documentElement.clientHeight || document.body.clientHeight

        vm.topRight = Math.round((wWidth - 1000) / 2) - 48
      },
      goTop () {
        console.log(document.documentElement.scrollTop || document.body.scrollTop)
        console.log(window)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }
    }
  }
</script>

<style scoped>
html,body {
  background-color: #f5f5f5;
}
.container {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f5f5f5;
  overflow: auto;
}

h1,h2,h3,h4,h5,hr {
  margin: 0;
}

.toTop {
  width: 48px;
  height: 49px;
  position: fixed;
  bottom: 180px;
  right: 100px;
  overflow: hidden;
}

.toTop:hover img {
  margin-left:-48px;
}
</style>





// WEBPACK FOOTER //
// ClassDetail.vue?d38f5f26